import setDocumentLineItems from "./actionFunctions";
import {
  type ActionFunction,
  type DocumentLineItemsAction,
  DocumentLineItemsActions,
  type DocumentLineState,
} from "./types";

const reducerMap: Record<DocumentLineItemsActions, ActionFunction> = {
  [DocumentLineItemsActions.ADD]: setDocumentLineItems,
};

export default function documentLineItemsReducer(
  state: DocumentLineState,
  emittedAction: DocumentLineItemsAction
): DocumentLineState {
  const { type, payload } = emittedAction;

  return reducerMap[type](state, payload);
}
